var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    attrs: { variant: "drawer-no-scroll", "no-footer": "" },
    scopedSlots: _vm._u(
      [
        {
          key: "default",
          fn: function (ref) {
            var activate = ref.activate
            return [_vm._t("default", null, null, { activate: activate })]
          },
        },
        {
          key: "body",
          fn: function (ref) {
            var deactivate = ref.deactivate
            var updateFocusable = ref.updateFocusable
            var getFocusableElements = ref.getFocusableElements
            return [
              _c("generic-list", {
                attrs: { items: _vm.items, deactivate: deactivate },
                on: {
                  "update-focusable": updateFocusable,
                  "get-focusable-elements": getFocusableElements,
                },
              }),
            ]
          },
        },
      ],
      null,
      true
    ),
    model: {
      value: _vm.isActive,
      callback: function ($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }